import script from "./GoToDPS.vue?vue&type=script&setup=true&lang=js"
export * from "./GoToDPS.vue?vue&type=script&setup=true&lang=js"

import "./GoToDPS.vue?vue&type=style&index=0&id=28dce738&lang=scss"

const __exports__ = script;

export default __exports__